import { Controller } from "@hotwired/stimulus"
import { marked } from "marked"

// Renders markdown from a hidden source element into an output container.
// Used for agent run final output display.
export default class extends Controller {
  static targets = ["source", "output"]

  connect() {
    this.render()
  }

  render() {
    if (!this.hasSourceTarget || !this.hasOutputTarget) return
    const raw = this.sourceTarget.textContent
    this.outputTarget.innerHTML = marked.parse(raw)
    this.sourceTarget.classList.add("hidden")
  }
}
